import { useI18n } from 'vue-i18n';

export const useNumberFormat = () => {
    const { n } = useI18n();

    /**
     * Format a crypto amount into a human-readable version
     * This returns a value with between 0 and 8 decimal places
     */
    const formatCrypto = (amount: number, isEstimation: boolean = false): string => {
        if (!amount && amount !== 0) {
            return;
        }

        if (!isEstimation) {
            return n(amount, 'crypto');
        }

        return '≈' + n(amount, 'crypto');
    };

    /**
     * Format a fiat amount into a human-readable version
     * This returns a value with exactly 2 decimal places
     */
    const formatFiat = (amount: number, currency?: string): string => {
        if (!amount && amount !== 0) {
            return;
        }

        if (!currency) {
            return n(amount, 'fiat');
        }

        return n(amount, { key: 'fiat', currency: currency }).replace('US', '');
    };

    /**
     * Format a fiat amount into a human-readable version
     * This returns a value with exactly the amount of provided decimal places
     */
    const formatDecimal = (amount: number, decimals?: number): string => {
        if (!amount && amount !== 0) {
            return;
        }

        const digits = decimals ?? 2;
        return n(amount, { key: 'number', minimumFractionDigits: digits, maximumFractionDigits: digits });
    };

    return {
        formatCrypto,
        formatDecimal,
        formatFiat
    };
};
